import { TextSkeleton, RoundSkeleton } from '@treezor/design-system';

export function OverviewItemLoader() {
  return (
    <div className="flex flex-col items-start w-full bg-primary border-2 px-6 py-5 border-primary rounded-200 gap-5">
      <div className="flex items-start justify-between w-full">
        <div className="flex flex-col gap-2">
          <TextSkeleton width={200} margin="0" />
          <TextSkeleton width={120} margin="0" />
        </div>
        <div className="flex items-center gap-3">
          <TextSkeleton width={120} margin="0" />
        </div>
      </div>

      <div className="flex items-center justify-between w-full">
        <div className="flex items-center gap-8">
          <div className="flex flex-col items-start gap-2">
            <TextSkeleton width={60} margin="0" />
            <TextSkeleton width={120} margin="0" />
          </div>
          <div className="flex flex-col items-start gap-2">
            <TextSkeleton width={60} margin="0" />
            <TextSkeleton width={120} margin="0" />
          </div>
        </div>

        <div className="flex items-center gap-3">
          <RoundSkeleton size={16} margin="2px" />
          <RoundSkeleton size={16} margin="2px" />
        </div>
      </div>
    </div>
  );
}
